import Loadable from 'react-loadable';
import ComponentLoading from 'components/ComponentLoading/ComponentLoading';
var LoadableGroupPostCompose = Loadable({
  loader: function loader() {
    return import('../GroupPostCompose.jsx');
  },
  loading: ComponentLoading
});
export default LoadableGroupPostCompose;